// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".q51UG{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8.8px}.q51UG>.form-group{-ms-flex:1 1 100%;flex:1 1 100%;margin-bottom:0}@media (min-width:600px){.q51UG>.form-group{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;-ms-flex-preferred-size:calc(50% - 8px);flex-basis:calc(50% - 8px)}}", ""]);
// Exports
exports.locals = {
	"phiSetFormPartial": "q51UG"
};
module.exports = exports;
